import React from "react";
import { Link } from "react-router-dom";
import {
  GridContainer,
  Block,
  Title,
  TopImageContainer,
  BottomImageContainer,
  BottomImageItem,
  TextImage,
  ResponsiveImage,
} from "./DualBlockStyles";
import { useYoutubeVideos } from "../../api/fetchExampleData";

const DualBlock = () => {
  const { data } = useYoutubeVideos();

  const videos = data?.videos || [];
  const shorts = data?.shorts.map((short) => ({
    ...short,
    title: short.title.replace(/#shorts/gi, "").trim(),
  })) || [];


  const renderCardContent = (items) => (
    <>
      {/* Immagine grande sopra */}
      <TopImageContainer>
        {items[0] && (
          <Link
            to={items[0].url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <ResponsiveImage src={items[0].thumbnail} alt={items[0].title} />
            <TextImage>{items[0].title}</TextImage>
          </Link>
        )}
      </TopImageContainer>

      {/* Due immagini sotto */}
      <BottomImageContainer>
        {items.slice(1, 3).map((item) => (
          <BottomImageItem key={item.id}>
            <Link
              to={item.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <ResponsiveImage src={item.thumbnail} alt={item.title} />
              <TextImage>{item.title}</TextImage>
            </Link>
          </BottomImageItem>
        ))}
      </BottomImageContainer>
    </>
  );

  return (
    <div style={{ padding: "1rem 0", margin: "1rem 0" }}>
      <GridContainer>
        {/* Card per i Video */}
        <Block>
          <Title>ROSSOMOTORI SUL TUBO</Title>
          {renderCardContent(videos)}
        </Block>

        {/* Card per gli Shorts */}
        <Block>
          <Title>ROSSOMOTORI SHORTS</Title>
          {renderCardContent(shorts)}
        </Block>
      </GridContainer>
    </div>
  );
};

export default DualBlock;
